export const getBillableCountriesRestApi = (HTTPSubscription) => HTTPSubscription.get('public/countries').then((res) => res.data);
//# sourceMappingURL=country.api.js.map